import React from "react";
import styled from "styled-components";
import loadable from "@loadable/component";

import { PageSection } from "../../components/layout/layout-styles";
import { TechnologyContentFallback } from "../../components/layout/section-skeleton";

const TechnologyFrame = loadable(() => import("./technology-frame"));

const Section = styled(PageSection)``;

const TechnologySection = () => {
  return (
    <Section name="technology" as="section">
      <TechnologyFrame fallback={<TechnologyContentFallback />} />
    </Section>
  );
};

export default TechnologySection;
